import React from "react";
import {
  Paper,
  Typography,
  Divider,
  Grid,
  Box,
  Avatar,
} from "@mui/material";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import FavoriteIcon from "@mui/icons-material/Favorite";
import BlockIcon from "@mui/icons-material/Block";

const StatItem = ({ icon, label, value, color }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      p: 2,
      borderRadius: 2,
      bgcolor: "background.paper",
      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
      transition: "transform 0.2s ease, box-shadow 0.2s ease",
      "&:hover": {
        transform: "translateY(-2px)",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      },
    }}
  >
    <Avatar
      sx={{
        bgcolor: color,
        mr: 2,
        width: 42,
        height: 42,
      }}
    >
      {icon}
    </Avatar>
    <Box>
      <Typography variant="body2" sx={{ color: "text.secondary" }}  px={0} py={0} m={0}>
        {label}
      </Typography>
      <Typography variant="h5" sx={{ fontWeight: "bold", color }}  px={0} py={0} m={0}>
        {value}
      </Typography>
    </Box>
  </Box>
);

const StatDetailsSection = ({ profile }) => {
  const stats = [
    {
      icon: <FavoriteIcon />,
      label: "Liked By Users",
      value: profile?.likedBy?.length || 0,
      color: "success.main",
    },
    {
      icon: <BlockIcon />,
      label: "Disliked By Users",
      value: profile?.dislikedBy?.length || 0,
      color: "error.main",
    },
    {
      icon: <ThumbUpAltIcon />,
      label: "Users You Liked",
      value: profile?.likedUsers?.length || 0,
      color: "primary.main",
    },
    {
      icon: <ThumbDownAltIcon />,
      label: "Users You Disliked",
      value: profile?.dislikedUsers?.length || 0,
      color: "warning.main",
    },
  ];

  return (
    <Paper
      elevation={4}
      sx={{
        p: 4,
        borderRadius: 3,
      }}
    >
      {/* Header */}
      <Typography
        variant="h5"
        sx={{
          fontWeight: "bold",
          color: "primary.main",
          mb: 2,
        }}
      >
        User Statistics
      </Typography>
      <Divider sx={{ mb: 3 }} />

      {/* Stats Grid */}
      <Grid container spacing={2}>
        {stats.map((stat, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <StatItem {...stat} />
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default StatDetailsSection;
